module.exports = __webpack_public_path__ + "static/media/Obedience03.ba30659d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Obedience03.jpg
// module id = 345
// module chunks = 0